<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header" class="p-2">
        {{ this.$route.meta.title }}
        <div class="card-header-actions"></div>
      </div>
      <b-input-group>
        <b-input-group-prepend
          ><label class="ml-2"
            >Current Date (Sistem)</label
          ></b-input-group-prepend
        >
        <b-form-input
          id="input-1"
          v-model="model.currentdate"
          type="date"
          :min="model.currentdate"
          :max="model.currentdate"
          disabled
        ></b-form-input>
        <b-input-group-prepend
          ><label class="ml-2">Next Date</label></b-input-group-prepend
        >
        <b-form-input
          id="input-1"
          v-model="model.nextdate"
          type="date"
          disabled
          class="mr-3"
        ></b-form-input>
        <b-button type="submit" variant="primary" @click="showConfirm = true"
          >Close Current Date (Sistem)</b-button
        >
      </b-input-group>
    </b-card>
    <b-modal
      v-model="showConfirm"
      title="Clossing"
      :centered="true"
      @ok="closeeod"
    >
      <p class="mb-1">You will Clossing?</p>
    </b-modal>
  </div>
</template>

<script>
import toastr from "mini-toastr";
toastr.init();
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import finance from "../../apis/finance";

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        currentdate: { required },
        nextdate: { required },
      },
  },
  data() {
    return {
      showConfirm: false,
      model: {
        currentdate: {
          minValue:moment(this.$store.state.timeServer).format("YYYY-MM-DD")
        },
        nextdate: {
          minValue:moment(this.$store.state.timeServer).format("YYYY-MM-DD")
        }
      },
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    user() {
      return this.$store.state.user;
    },
    timeServer() {
      if (this.$store.state) {
        return this.$store.state.timeServer;
      } else {
        return "";
      }
    },
  },
  created: async function () {
    (this.model.currentdate = moment(this.$store.state.timeServer).format(
      "YYYY-MM-DD"
    )),
      (this.model.nextdate = moment(this.$store.state.timeServer)
        .add(1, "days")
        .format("YYYY-MM-DD"));
  },
  methods: {
    async closeeod(event) {
      try {
        if (this.invalidModel) {
          toastr.error("Please fill the form correctly.", "Error Info"); 
          return;    
        }

        if(this.model.currentdate=="Invalid date"){
          toastr.error("Please fill the form correctly.", "Error Info");
          return;
        }
        await finance.closeeod(this.model);
        router.push({ name: "paylater.home" });
      } catch (error) {
        toastr.error(JSON.stringify(error), "Error Info");
      }
    },
  },
};
</script>